import React, { useState, useEffect } from "react";
import ptcImage from '../imagenes/ptc.jpg';
import { urlApiProd, print } from './utiles';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import axios from 'axios';
import Alert from 'react-bootstrap/Alert';
import SistemaToast from '../components/SistemaToast/SistemaToast';
import { clearSessionStorage } from '../auth/session';


function Login({ onLogin }) {
    const [correo, setCorreo] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const fetchMessage = () => {
        setLoading(true);
        setSuccess(false);
        axios.get(urlApiProd)
            .then(response => {
                setMessage(response.data.message);
                setError('');
                setSuccess(true); // Indicar que la solicitud fue exitosa
            })
            .catch(error => {
                if (error.response) {
                    setError(`No pudimos conectar con el servidor (${error.response.status}). Vuelve a intentarlo.`);
                } else if (error.request) {
                    setError('No pudimos conectar con el servidor, inténtalo de nuevo.');
                } else {
                    setError('No pudimos iniciar la conexión. Inténtalo nuevamente.');
                }
                print(`There was an error fetching the data! ${error}`);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        clearSessionStorage();
        fetchMessage();
        const reason = new URLSearchParams(window.location.search).get('reason');
        if (reason === 'expired') {
            setMensaje('Tu sesión expiró. Por favor inicia sesión nuevamente.');
            setShow(true);
        } else if (reason === 'unauthorized' || reason === 'invalid_session') {
            setMensaje('Tu sesión no es válida. Por favor inicia sesión nuevamente.');
            setShow(true);
        }
    }, []);


    function handleLogin() {
        setError('');
        const userData = {
            correo: correo,
            password: password
        };


        fetch(`${urlApiProd}/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(userData),
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(err => {
                        throw new Error(err.error || 'Error al iniciar sesión');
                    });
                }
                return response.json();
            })
            .then(data => {
                print(data);
                const accessToken = data.access_token || data.token;
                localStorage.setItem('token', accessToken); // compatibilidad
                localStorage.setItem('access_token', accessToken);
                localStorage.setItem('refresh_token', data.refresh_token || '');
                localStorage.setItem('Nombre', data.Nombre);
                localStorage.setItem('Rol', data.Rol);
                localStorage.setItem('RolMenu', data.RolMenu);
                localStorage.setItem('ID_Usuario', data.ID_Usuario);
                localStorage.setItem('correo', data.correo);
                localStorage.setItem('loggedIn', true);
                //setShow(true);
                //alert('Bienvenido!');
                window.location.href = '/home';
            })
            .catch(error => {
                if (error.message === 'Credenciales inválidas') {
                    setMensaje('Favor verificar correo o contraseña.');
                    setShow(true);
                    //alert('Credenciales inválidas. Por favor, verifica tu correo y contraseña.');
                } else {
                    //alert('Ocurrió un problema al iniciar sesión. Inténtalo de nuevo más tarde.');
                    setMensaje('Ocurrió un problema, favor volver a intentar.');
                    setShow(true);
                    setError('Verifica la conexión e intenta nuevamente.');
                }
                print('Error:', error);
            });
    }


    const [show, setShow] = useState(false);
    const [mensaje, setMensaje] = useState('Favor verificar correo o contraseña.');


    return (
        <div>
            <SistemaToast
                show={show}
                message={mensaje}
                onClose={() => setShow(false)}
                zIndex={3100}
            />
            <div>
                {!loading && success && 1 === 2 && <Alert className="text-center" key='primary' variant='primary'>
                    Conexión con servidor funcionando correctamente
                </Alert>}
            </div>
            <div className="modal2" style={{ width: '500px' }}>
                <img
                    src={ptcImage}
                    alt="PTC"
                    style={{
                        display: 'block',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        paddingBottom: 10,
                        width: '100%', // ocupa todo el ancho del contenedor
                        maxWidth: '150px', // opcional: define un tamaño máximo para la imagen
                        height: 'auto' // mantiene la proporción de la imagen
                    }}
                />
                <h5 style={{ textAlign: 'center' }}><strong>Bienvenido al ERP</strong></h5>
                <div className="card" style={{ marginTop: 20 }}>
                    <div className="card-header">
                        <h2 className="mt-4" style={{ textAlign: 'center', paddingBottom: 15 }}>Inicia sesión</h2>
                    </div>
                    <div className="card-body">
                        <div className="input-group mb-3">
                            <label htmlFor="usuario" className="input-group-text">
                                Correo
                            </label>
                            <input
                                type="email"
                                className="form-control"
                                value={correo}
                                onChange={e => setCorreo(e.target.value)}
                            />
                        </div>

                        <div className="input-group mb-3">
                            <label htmlFor="password" className="input-group-text">
                                Contraseña
                            </label>
                            <input
                                type="password"
                                className="form-control"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            />
                        </div>
                        {!!error && (
                            <div className="mb-2" style={{ color: '#b02a37', fontSize: '0.9rem', textAlign: 'center' }}>
                                {error}
                            </div>
                        )}
                    </div>
                    <div className='card-footer' style={{ textAlign: 'center' }}>
                        <button onClick={handleLogin} className="btn btn-success btn-lg mt-3 mb-3">
                            Iniciar sesión
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
